import HttpResponse from "../../../../../../utils/http/http.response";

export enum DriverPlanEntryCheckoutEventAddErrorResponseErrorType {
  DRIVER_HAS_CANDIDATURE = "DRIVER_HAS_CANDIDATURE",
}

export type DriverPlanEntryCheckoutEventAddNotAcceptableResponseDriverHasCandidatureError =
  {
    errorType: DriverPlanEntryCheckoutEventAddErrorResponseErrorType.DRIVER_HAS_CANDIDATURE;
    candidatureId: string;
  };

export type DriverPlanEntryCheckoutEventAddNotAcceptableResponseError =
  DriverPlanEntryCheckoutEventAddNotAcceptableResponseDriverHasCandidatureError;

export type DriverPlanEntryCheckoutEventAddErrorResponse =
  HttpResponse<DriverPlanEntryCheckoutEventAddNotAcceptableResponseError>;

export type DriverPlanEntryCheckoutEventAddSuccessResponse = HttpResponse;

type DriverPlanEntryCheckoutEventAddResponse =
  | DriverPlanEntryCheckoutEventAddSuccessResponse
  | DriverPlanEntryCheckoutEventAddErrorResponse;

export default DriverPlanEntryCheckoutEventAddResponse;
